import React, { useEffect, useState } from "react";
import Web3 from "web3";
import { useAppKitAccount } from "@reown/appkit/react";
import { useConnectorClient } from "wagmi";
import { ITreasureContract,NFTContarct ,USDTContarct} from "../config/contractConfig";
import ITreasureContractABI from "../abis/ITreasureContractABI.json";
import NFTABI from "../abis/NFTABI.json";
import USDTABI from "../abis/USDTABI.json";

import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";

import Nodata from "../assets/img/no-record-found.png";
import {
  FaWallet,
  FaHashtag,
  FaMoneyBillWave,
  FaBoxOpen,
  FaClock,
  FaCopy,
  FaCheck,
  FaFilter
} from "react-icons/fa";

const CTObonus = () => {
  const navigate = useNavigate();


  const [showCriteria, setShowCriteria] = useState(false);




  const { address, isConnected } = useAppKitAccount();
  const { data: client } = useConnectorClient();
  const [loading, setLoading] = useState(true);

  const [web3, setWeb3] = useState(null);
  const [bonusList, setBonusList] = useState([]);
  const [poolValue, setPoolValue] = useState("0.00");

  const [searchValue, setSearchValue] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  const [copiedIndex, setCopiedIndex] = useState(null);

    // 🔹 Royalty Participate States
  const [showRoyaltyBox, setShowRoyaltyBox] = useState(false);
  const [royaltyNFTCount, setRoyaltyNFTCount] = useState("");
  const [royaltyAmount, setRoyaltyAmount] = useState(0);
  const [royaltyLoading, setRoyaltyLoading] = useState(false);
  const [royaltyMsg, setRoyaltyMsg] = useState("");
  const ROYALTY_PRICE = 200; // USDT per NFT

  const formatBalance = (balance) =>
    balance ? parseFloat(balance).toFixed(4) : "0.00";

  // INIT WEB3
  useEffect(() => {
    let provider = null;

    if (client?.transport) provider = client.transport;
    else if (window.ethereum) provider = window.ethereum;

    if (!provider) return;

    const w3 = new Web3(provider);
    setWeb3(w3);
  }, [client]);

  // FETCH ON CONNECT
  useEffect(() => {
    if (isConnected && address && web3) {
      fetchCTObonus();
      fetchSystemDetails();
    }
  }, [address, isConnected, web3]);

   // ================= AUTO USDT CALC =================
  useEffect(() => {
    if (!royaltyNFTCount || isNaN(royaltyNFTCount)) {
      setRoyaltyAmount(0);
      return;
    }
    setRoyaltyAmount(Number(royaltyNFTCount) * 200); // 1 NFT = 200 USDT
  }, [royaltyNFTCount]);

  // Navigate
  const handleCTOUserClick = (tab) => {
    if (tab == 1) {
      navigate("/all-royalty-users");
    } else if (tab == 2) {
      navigate("/monthly-trading-history");
    }
  };

  // FETCH CTO BONUS
  const fetchCTObonus = async () => {
    setLoading(true);
    try {
      const contract = new web3.eth.Contract(
        ITreasureContractABI,
        ITreasureContract
      );

      const result = await contract.methods.reward_details(address).call();

      const reward_timestamp = result._reward_timestamp || [];
      const reward_credited = result._reward_credited || [];
      const reward_type = result._reward_type || [];
      const reward_level = result._reward_level || [];
      const reward_from = result._reward_from || [];
      const reward_package = result._reward_package || [];

      const formatted = reward_type
        .map((type, i) => {
          if (Number(type) === 3) {
            const rawDate = new Date(Number(reward_timestamp[i]) * 1000);

            return {
              from: reward_from[i],
              amount: Web3.utils.fromWei(
                reward_credited[i].toString(),
                "ether"
              ),
              timestamp: rawDate.toLocaleString(),
              dateRaw: rawDate,
              package: Number(reward_package[i]),
              level: Number(reward_level[i]),
            };
          }
          return null;
        })
        .filter(Boolean);

      setBonusList(formatted.reverse());
    } catch (err) {
      console.log("Error:", err);
    }
    setLoading(false);
  };

  // FETCH SYSTEM DETAILS
  const fetchSystemDetails = async () => {
    try {
      const contract = new web3.eth.Contract(
        ITreasureContractABI,
        ITreasureContract
      );
      const result = await contract.methods.getSystemDetails().call();

      const ctoCommission = web3.utils.fromWei(
        result[5].toString(),
        "ether"
      );

      setPoolValue(formatBalance(ctoCommission));
    } catch (error) {
      console.error("Error fetching tPool:", error);
    }
  };

  // ================= PARTICIPATE FUNCTION =================
  const handleParticipateRoyalty = async () => {
    if (!isConnected) {
      alert("Please connect wallet");
      return;
    }

    if (!royaltyNFTCount || Number(royaltyNFTCount) <= 0) {
      alert("Enter valid NFT count");
      return;
    }

    try {
      setRoyaltyLoading(true);
      setRoyaltyMsg("");
     const nftCount = Number(royaltyNFTCount);

     // 🔹 total USDT needed
    const totalAmount = Web3.utils.toWei(
      (nftCount * ROYALTY_PRICE).toString(),
      "ether"
    );

     const usdtContract = new web3.eth.Contract(
       USDTABI,
      USDTContarct
    );
      const contract = new web3.eth.Contract(
        NFTABI,
        NFTContarct
      );

      // 🔹 STEP 1: check allowance
    const allowance = await usdtContract.methods
      .allowance(address, NFTContarct)
      .call();

    // 🔹 STEP 2: approve if needed
    if (window.BigInt(allowance) < window.BigInt(totalAmount)) {
      setRoyaltyMsg("⏳ Approving USDT...");

      await usdtContract.methods
        .approve(NFTContarct, totalAmount)
        .send({ from: address });
    }

    // 🔹 STEP 3: call participate function
    setRoyaltyMsg("⏳ Processing royalty participation...");

      await contract.methods
        .participateInRoyalty(royaltyNFTCount)
        .send({ from: address });

      setRoyaltyMsg("✅ Royalty participation successful!");
      setRoyaltyNFTCount("");
      setRoyaltyAmount(0);
    } catch (err) {
      console.error(err);
      setRoyaltyMsg(err?.message || "Transaction failed");
    } finally {
      setRoyaltyLoading(false);
    }
  };

  // FILTER LOGIC FIXED
  const filteredData = bonusList.filter((item) => {
    const val = searchValue.toLowerCase();

    const dateOk =
      (!fromDate || item.dateRaw >= new Date(fromDate)) &&
      (!toDate || item.dateRaw <= new Date(toDate));

    return (
      dateOk &&
      (item.from.toLowerCase().includes(val) ||
        item.amount.toString().includes(val) ||
        item.timestamp.toLowerCase().includes(val))
    );
  });

  // PAGINATION
  const indexOfLast = currentPage * recordsPerPage;
  const indexOfFirst = indexOfLast - recordsPerPage;
  const currentRecords = filteredData.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredData.length / recordsPerPage);

  // COPY
  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(null), 1500);
  };

  const resetFilters = () => {
    setSearchValue("");
    setFromDate("");
    setToDate("");
  };
  if (loading) return <Loader />;






  return (
    <div className="buyshheikh-page">

      {/* HEADER */}
      <h4 className="mb-3 mobilefiltername">
        <div>
          <span className="text-warning"> Royalty </span>{" "}
          <span className="fw-lighter"> Bonus</span>
        </div>

        <button
          className="btn btn-light btn-sm"
          onClick={() => setMobileFilterOpen(true)}
        >
          <FaFilter /> Filter
        </button>
      </h4>

      {/* FILTER BOX */}
      <div className="card paddingfilter">
        <div className="card-body">

          {/* MOBILE FILTER OVERLAY */}
          {mobileFilterOpen && (
            <div
              className="overlay-bg"
              onClick={() => setMobileFilterOpen(false)}
            />
          )}

          <div
            className={`bottom-filter-panel ${mobileFilterOpen ? "show" : ""
              }`}
          >
            <div
              className="close-filter"
              onClick={() => setMobileFilterOpen(false)}
            >
              ✕
            </div>

            <div className="row">
              <div className="col-md-12 col-lg-2 mb-3">
                <label className="form-label">From Date</label>
                <div className="input-icon">
                  <input
                    type="date"
                    className="form-control"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                  <i className="fa-solid fa-calendar iconposition"></i>
                </div>
              </div>

              <div className="col-md-12 col-lg-2 mb-3">
                <label className="form-label">To Date</label>
                <div className="input-icon">
                  <input
                    type="date"
                    className="form-control"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                  />
                  <i className="fa-solid fa-calendar iconposition"></i>
                </div>
              </div>

              <div className="col-md-12 col-lg-3 mb-3">
                <label className="form-label">Search</label>
                <div className="input-icon">
                  <input
                    type="text"
                    className="form-control only-inputypetext"
                    placeholder="Search..."
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                  />
                  <i className="fa-solid fa-magnifying-glass iconposition"></i>
                </div>
              </div>

              <div className="col-md-12 col-lg-2 mb-3">
                <label className="form-label invisible">Apply</label>
                <div className="d-flex gap-2 mobleapplybtn">
                  <button
                    className="btn btn-success"
                    onClick={() => setMobileFilterOpen(false)}
                  >
                    Apply
                  </button>
                  <button className="btn btn-danger" onClick={resetFilters}>
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* <button
                    onClick={handleCTOUserClick(1)}
                    className="btn btn-warning"
                  >
                     Check Royalty User
                  </button>

                   <button
                    onClick={handleCTOUserClick(2)}
                    className="btn btn-warning"
                  >
                     Monthly Trading History
                  </button> */}



          {/* CTO POOL + BUTTON */}
          {/* <div className="col-12 mt-3">
            <div className="card CTO_users">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h3 className="text-warning">
                      {poolValue ? `${poolValue} USDT` : "Loading..."}
                    </h3>
                    <p>💰 Total Royalty Pool    </p>
                  </div>


 <button 
                    className="btn btn-warning"
                  >
                    Check Royalty Criteria
                  </button>




                    <button onClick={() => navigate("/all-royalty-users")}  className="btn btn-warning">
                      Check Royalty User
                    </button>
                    
                    <button onClick={() => navigate("/monthly-trading-history")}  className="btn btn-warning">
                      Monthly Trading History
                    </button>
                </div>
              </div>
            </div>
          </div> */}





          <div className="col-12 mt-3">
            <div className="card CTO_users royalty-card-ui">
              <div className="card-body">
                <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">

                  {/* LEFT */}
                  <div className="royalty-info-ui">
                     <h3 className="text-warning">
                      {poolValue ? `${poolValue} USDT` : "Loading..."}
                    </h3>
                    <p className="mb-0 text-white">
                      💰 Total Royalty Pool
                    </p>
                  </div>

      {/* ================= ROYALTY PARTICIPATION POPUP ================= */}
       {showRoyaltyBox && (
  <div
    className="royalty-popup-overlay"
    onClick={() => setShowRoyaltyBox(false)}
  >
    <div
      className="royalty-popup"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="popup-header">
        <h4>🔥 Participate in Royalty</h4>
        <span
          className="close-btn"
          onClick={() => setShowRoyaltyBox(false)}
        >
          ✕
        </span>
      </div>

      <div className="popup-content">
        <div className="form-group mb-3">
          <label>Enter Royalty NFT Count</label>
          <input
            type="number"
            min="1"
            className="form-control"
            placeholder="1, 2, 3..."
            value={royaltyNFTCount}
            onChange={(e) => setRoyaltyNFTCount(e.target.value)}
          />
        </div>

        <div className="form-group mb-3">
          <label>USDT Amount</label>
          <input
            type="text"
            className="form-control"
            readOnly
            value={
              royaltyAmount > 0
                ? `${royaltyAmount} USDT`
                : "0 USDT"
            }
          />
        </div>

        <p style={{ fontSize: "13px", opacity: 0.8 }}>
          ℹ️ Each Royalty NFT costs <b>200 USDT</b>.  
          Amount will be sent to company burning wallet.
        </p>

        <button
          className="btn btn-warning w-100"
          disabled={royaltyLoading}
          onClick={handleParticipateRoyalty}
        >
          {royaltyLoading ? "Processing..." : "Confirm & Participate"}
        </button>

        {royaltyMsg && (
          <div
            style={{
              marginTop: "10px",
              color: royaltyMsg.includes("✅") ? "green" : "red",
              fontSize: "13px",
            }}
          >
            {royaltyMsg}
          </div>
        )}
      </div>
    </div>
  </div>
)}

                  {/* RIGHT */}
                  <div className="d-flex flex-wrap gap-2 action-btn-ui">
                    <button
                      className="btn btn-warning btn-primary-ui"
                      onClick={() => setShowRoyaltyBox(true)}
                    >
                      Participate Royalty
                    </button>
                    <button
                      className="btn btn-warning btn-primary-ui"
                      onClick={() => setShowCriteria(true)}
                    >
                      Check Royalty Criteria
                    </button>
                    <button onClick={() => navigate("/all-royalty-users")} className="btn btn-outline-warning btn-secondary-ui">
                      Check Royalty User
                    </button>
                    <button onClick={() => navigate("/monthly-trading-history")} className="btn btn-outline-warning btn-secondary-ui">
                      Monthly Trading History
                    </button>
                  </div>


                </div>
              </div>
            </div>
          </div>

       {/* POPUP */}
{showCriteria && (
  <div
    className="royalty-popup-overlay"
    onClick={() => setShowCriteria(false)}
  >
    <div
      className="royalty-popup"
      onClick={(e) => e.stopPropagation()}
    >
      {/* ===== HEADER ===== */}
      <div className="popup-header">
        <h4>🏆 Royalty Eligibility Criteria</h4>
        <span
          className="close-btn"
          onClick={() => setShowCriteria(false)}
        >
          ✕
        </span>
      </div>

      {/* ===== CONTENT ===== */}
      <div className="popup-content">

        <ol>
          <li>
            Requires a minimum self-purchased package of <b>$400 or more</b>.
          </li>
          <li>
            Daily trading activity is required every <b>24-hour</b> period of the month.
          </li>
          <li>
            Minimum of <b>20 times</b> daily trading volume must be completed within the month.
          </li>
        </ol>

        {/* ===== TRADING REQUIREMENTS TABLE ===== */}
        <h6 className="mt-3 text-warning">Trading Volume Requirements</h6>

        <table className="table table-bordered table-dark table-sm mt-2">
          <thead>
            <tr>
              <th>Package (USDT)</th>
              <th>Daily Trading Limit (USDT)</th>
              <th>Monthly Eligible Volume (USDT)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>400</td>
              <td>4,000</td>
              <td>80,000</td>
            </tr>
            <tr>
              <td>600</td>
              <td>6,000</td>
              <td>1,20,000</td>
            </tr>
            <tr>
              <td>1,000</td>
              <td>10,000</td>
              <td>2,00,000</td>
            </tr>
            <tr>
              <td>1,500</td>
              <td>15,000</td>
              <td>3,00,000</td>
            </tr>
          </tbody>
        </table>

        {/* ===== NFT BURNING TABLE ===== */}
        <h6 className="mt-4 text-warning">Royalty NFT Burning Requirements</h6>

        <table className="table table-bordered table-dark table-sm mt-2">
          <thead>
            <tr>
              <th>Package (USDT)</th>
              <th>Royalty NFT Burning</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>400</td>
              <td>3 NFTs</td>
            </tr>
            <tr>
              <td>600</td>
              <td>6 NFTs</td>
            </tr>
            <tr>
              <td>1,000</td>
              <td>9 NFTs</td>
            </tr>
            <tr>
              <td>1,500</td>
              <td>12 NFTs</td>
            </tr>
          </tbody>
        </table>

      </div>

      {/* ===== FOOTER ===== */}
      <div className="popup-footer">
        <button
          className="btn btn-warning w-100"
          onClick={() => setShowCriteria(false)}
        >
          Got it
        </button>
      </div>
    </div>
  </div>
)}



          {/* RECORDS */}
          <div className="mt-3">
            <div className="row">
              {currentRecords.length > 0 ? (
                currentRecords.map((item, index) => {
                  const masked =
                    item.from.substring(0, 2) +
                    "****" +
                    item.from.substring(item.from.length - 2);

                  return (
                    <div className="col-md-6 col-lg-4 mb-4" key={index}>
                      <div className="ref-card">
                        <div className="ref-card-body">

                          {/* S.NO */}
                          <div className="ref-row">
                            <span className="ref-label">
                              <FaHashtag className="ref-icon" /> S.No.
                            </span>
                            <span className="ref-value">
                              {index + 1 + indexOfFirst}
                            </span>
                          </div>

                          {/* FROM WALLET */}
                          <div className="ref-row">
                            <span className="ref-label">
                              <FaWallet className="ref-icon" /> From Wallet
                            </span>

                            <div className="ref-copy-box">
                              <span className="ref-value">{masked}</span>

                              <button
                                className="copy-btn"
                                onClick={() =>
                                  handleCopy(item.from, index)
                                }
                              >
                                {copiedIndex === index ? (
                                  <FaCheck className="copy-icon copied" />
                                ) : (
                                  <FaCopy className="copy-icon" />
                                )}
                              </button>
                            </div>
                          </div>

                          {/* AMOUNT */}
                          <div className="ref-row">
                            <span className="ref-label">
                              <FaMoneyBillWave className="ref-icon" /> Amount
                            </span>
                            <span className="ref-badge">{formatBalance(item.amount)}</span>
                          </div>

                          {/* PACKAGE */}
                          <div className="ref-row">
                            <span className="ref-label">
                              <FaBoxOpen className="ref-icon" /> Rank
                            </span>
                            <span className="ref-value">
                              {item.level}
                            </span>
                          </div>

                          {/* DATE */}
                          <div className="ref-row">
                            <span className="ref-label">
                              <FaClock className="ref-icon" /> Date & Time
                            </span>
                            <span className="ref-date">{item.timestamp}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="no-data">
                  <img src={Nodata} alt="" />
                </div>
              )}
            </div>

            {/* PAGINATION */}
            {totalPages > 1 && (
              <div className="pagination-div">
                <ul className="pagination mb-0">
                  {[...Array(totalPages)].map((_, idx) => (
                    <li
                      key={idx}
                      className={`page-item ${currentPage === idx + 1 ? "active" : ""
                        }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setCurrentPage(idx + 1)}
                      >
                        {idx + 1}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default CTObonus;
